export default __webpack_public_path__ + "static/media/prophouse-tos.d4f29d36.pdf";